<template>
  <div :class="isSushiHub && 'montserrat-500'">
  <div class="mobile-wrapper" v-if="storeMenu && getloadedMenu">
    <!--Coupons-->
    <div     :style="this.showModal ? 'display:none' : ''">
    <shop-header
      @show-reorder="u=>isShowReorder = u"
      @show-search="showSearchBox = true"
      :showPopular="isShowPopular"
      :showSearchBox="showSearchBox"
      :menu="JSON.parse(JSON.stringify(storeMenu))"
      :store-id="storeid"
      :categories="storeMenu.Categories"
      @filterText="filterTextchange"
      :isSushi="isSushi"
      :modalOpen="this.showModal"

    />
    <div class="pt-4" v-if="isSushi"></div>
    <div  class="content-padding-double" :style="{'height':`${getHeight}px`}" />
    </div>

      <div class="container-fluid mobile-menu-content">
      <ProductList
        :menu="JSON.parse(JSON.stringify(storeMenu))"
        @show-search="showSearchBox = false"
        @show-popular="setPopularVisibility"
        :showSearchBox="showSearchBox"
        :filterText="filterText"
        :show-reorder="isShowReorder"
        :isSushi="isSushi"
        :modalOpen="this.showModal"
        @toggleIndex="toggleIndex()"
        :storeId="storeid"
      />
    </div>


  </div>

    <order-type v-if="showOrderTypePopup"></order-type>
    <enter-name v-if="showEnterNamePopUp && showSharedCart" />
    <order-placed v-if="getModalProp" />
  </div>
</template>
<script>
import ProductList from "./products/ProductListMobile";
import ShopHeader from "./partials/shopheaderMobile";
import { mapMutations, mapActions, mapGetters } from "vuex";
import sharedScripts from '../../sharedscripts/shop/Shop';
import HomePageMobile from './homePageMobile.vue';
import OrderType from "./OrderType";
import {orderTypeHelper} from "@/api/helpers/orderTypeHelper";
import { CONSTANT_ORDER_TYPE_DINEIN } from '../../constans/strings';
import EnterName from "../user/EnterName.vue";
import OrderPlaced from '../shared/OrderPlaced.vue';

export default {
  components: {
    ProductList,
    ShopHeader,
    OrderType,
    EnterName,
    OrderPlaced,
  },
  props: {
    storeid: {
      type: String,
      default: ""
    }
  },
  mixins: [HomePageMobile],
  data() {
    return {
      showSearchBox: false,
      isShowPopular: true,
      isShowReorder: true,
      filterText:"",
      showTerm:false,
      showOrderTypeSelection: true,
      multipleMenus: true,

      // check if the store has multiple menus
      loading: true,
    };
  },
  async created() {
    if(this.currentStoreDoc && this.storeid != this.currentStoreDoc.ID)
    {
      this.setCurrentStoreDoc(null);
    }
    this.initPriceTriggers(this.storeid);
    if (
        this.currentStoreDoc &&
        this.currentStoreDoc.ViewComponentConfigs.MultipleMenus === false
    ) {
      this.multipleMenus = false;
    }
    if (this.$route.query.table) {
      orderTypeHelper.setOrderTypeDineIn();
      this.setSelectedMenuType(CONSTANT_ORDER_TYPE_DINEIN);
    }
  },
  mounted() {
    const self = this;
    this.setStore(this.storeid);
    this.initStore({
      storeId: this.storeid,
      callback: () => {
        self.initiateWorkflow();
        this.loading = false;
      },
    });
    this.getStoreMenu(this.storeid);
    this.getProductStatuses(this.storeid);
    if (!sessionStorage.getItem("paymenttype")) {
      sessionStorage.setItem(
        "paymenttype",
        new URLSearchParams(window.location.search).get("paymenttype")
      );
    }
    this.updateShoppingCartItems();
  },
  updated() {
    if (this.showSharedCart) {
      this.getTableOrder(this.storeid);
    }
  },
  computed: {
    ...sharedScripts.computed,
    ...mapGetters([
      "storeMenu",
      "getloadedMenu",
      "selectedCompany",
      "currentStoreDoc",
      "showSharedCart",
      "getModalProp",
    ]),
    getHeight() {
      var result = (!this.isShowPopular && this.isShowReorder) ? 334 : 158;

      // if (this.showSearchBox) {
      //   result -= 50;
      // }
      return result;
    },
    isSushi(){
      return this.hqDoc && this.hqDoc.IsSushiHub
    },
    showModal(){
      return this.showTerm
    },
    showOrderTypePopup() {
      return (
          !this.loading &&
          this.showOrderTypeSelection &&
          this.multipleMenus &&
          !this.$route.query.table
      );
    },
    showEnterNamePopUp() {
      return this.$route.query.table;
    }
  },
  watch: {
    ...sharedScripts.watch,
  },
  methods: {
    ...sharedScripts.methods,
    ...mapMutations(["setStore","setCurrentStoreDoc"]),
    ...mapActions([
      "initStore",
      "getStoreMenu",
      "insertErrorlog",
      "redirectToErrorPage",
      "initPriceTriggers",
      "updateShoppingCartItems",
      "getProductStatuses",
      "getTableOrder",
    ]),
    filterTextchange (txt){
      this.filterText = txt;
    },
    setPopularVisibility(isVisible) {
      this.isShowPopular = isVisible;
    },


    closeModal() {
      this.showTerm = false;
    },
    toggleIndex() {
      this.showTerm = !this.showTerm;
    }

  }
};
</script>
